module.exports = __webpack_public_path__ + "img/icon_gongneng4.35da9f5e.svg";